<template>
	<v-list>
		<v-list-tile>
			<v-list-tile-content>
				<v-list-tile-title>{{ feature.name }}</v-list-tile-title>
				<v-list-tile-sub-title>{{ feature.description }}</v-list-tile-sub-title>
			</v-list-tile-content>
			<v-list-tile-action>
				<!-- Bind v-model directly for reactivity -->
				<div v-for="action in feature.availableActions" :key="action" class="ml-3">
					<v-checkbox
						:label="getActionLabel(feature, action)"
						:value="action"
						v-model="selectedActions"
						@change="onActionChange"
					/>
				</div>
			</v-list-tile-action>
		</v-list-tile>
	</v-list>
</template>

<script>
import PermissionAction from '@/enums/permissionAction';

export default {
	props: {
		/**
		 * The feature details, including available actions.
		 */
		feature: {
			type: Object,
			required: true
		},
		/**
		 * The current feature permission for the feature, including selected actions.
		 */
		featurePermission: {
			type: Object,
			default: () => ({
				featureId: null,
				actions: []
			})
		}
	},
	data() {
		return {
			selectedActions: [] // Local binding for checkbox reactivity
		};
	},
	watch: {
		// Synchronize selected actions with the input prop
		featurePermission: {
			immediate: true,
			deep: true,
			handler(newVal) {
				this.selectedActions = [...newVal.actions];
			}
		}
	},
	methods: {
		/**
		 * Emit changes to the parent component when actions change.
		 */
		onActionChange() {
			this.$emit("update-feature-permission", {
				featureId: this.feature.featureId,
				actions: [...this.selectedActions] // Pass updated actions
			});
		},
        getActionLabel(feature, action) {
            if (feature.availableActions.length === 1 && action === PermissionAction.USE) {
                return '';
            }

            return action;
        }
	}
};
</script>

<style scoped>
.v-list__tile__action {
	flex-direction: row;
}
</style>
